import { INITO_TRACKS_EVERYTHING_IMAGES } from "../constants";

export default function InitoTracksEverything() {
  return (
    <div className="mx-auto relative overflow-hidden md:max-w-[500px]">
      <div className="max-w-[350px] mx-5 mt-12 text-[#122d35] md:max-w-[500px] md:px-[5px] md:pr-5">
        <h2 className="title-32 text-[#232221] my-4">
          Inito tracks everything so you don&apos;t have to
        </h2>
        <p className="title-16 text-[#112d35] mb-4">
          The Inito Fertility Monitor comes with a free easy-to-use App, so you
          can track your fertile days with ease and know exactly when you
          ovulate.
        </p>
        <p className="title-16 text-[#112d35] mb-4">
          Our App notifies you for everything:
        </p>
        <ul className="title-16 text-[#112d35] mt-5 list-disc">
          <li className="ml-5">Your fertility levels</li>
          <li className="ml-5">When to test on the right days</li>
          <li className="ml-5">When you&apos;ve successfully ovulated</li>
          <li className="ml-5">And when to roll into bed!</li>
        </ul>
      </div>
      <div
        className="relative w-full h-[370px] overflow-hidden flex items-end"
        style={{
          background:
            "linear-gradient(180deg, rgba(220, 222, 228, 0) 0%, #DCDEE4 100%)",
        }}
      >
        <div className="flex w-full justify-center items-end">
          <div className="grid w-[289px] h-[307px] [&>img]:col-start-1 [&>img]:col-end-1 [&>img]:row-start-1 [&>img]:row-end-1 [&>img]:w-[289px] [&>img]:h-[307px] [&>img]:object-contain [&>img]:opacity-0 [&>img]:animate-[imageSeq_12s_steps(1,end)_infinite] [&>img:nth-child(1)]:opacity-100 [&>img:nth-child(1)]:[animation-delay:0ms] [&>img:nth-child(2)]:[animation-delay:3000ms] [&>img:nth-child(3)]:[animation-delay:6000ms] [&>img:nth-child(4)]:[animation-delay:9000ms]">
            {INITO_TRACKS_EVERYTHING_IMAGES.map((src, i) => (
              // eslint-disable-next-line @next/next/no-img-element
              <img key={src} src={src} alt={`Why Inito frame ${i + 1}`} />
            ))}
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes imageSeq {
          0% { opacity: 1; }
          25% { opacity: 1; }
          25.01% { opacity: 0; }
          100% { opacity: 0; }
        }
      `}</style>
    </div>
  );
}
